export function suspend<T>(): Promise<T> {
	return new Promise(() => undefined);
}
